import { debounce } from "lodash-es";
import shallowEqual from "../../lib/utils/shallowEqual";
export const tabsContainerMixin = {
  data() {
    return {
      allTabs: []
    };
  },
  provide() {
    return {
      'uicore:WTabs': this
    };
  },
  created() {
    this.allTabsSet = new Set();
    this.syncAllTabs = debounce(this.syncAllTabs, 0, {
      leading: true,
      trailing: true
    });
  },
  methods: {
    syncAllTabs() {
      const newArray = Array.from(this.allTabsSet).filter(it => it === null || it === void 0 ? void 0 : it.isTabPane).sort((a, b) => a.index - b.index);
      if (shallowEqual(this.allTabs, newArray)) return;
      this.allTabs = Object.freeze(newArray);
    },
    registerTabPane(tab) {
      if (!(tab !== null && tab !== void 0 && tab.isTabPane)) return;
      tab.$once('hook:beforeDestroy', () => {
        this.allTabsSet.delete(tab);
        this.syncAllTabs();
      });
      this.allTabsSet.add(tab);
      this.syncAllTabs();
      tab.$watch(() => tab.index, this.syncAllTabs);
    }
  }
};